import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;
  justify-items: start;
`

export const Rules = styled.div`
  display: grid;
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: ${Colors.GS600};
`
